// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  white-space: nowrap;
  margin-right: 8px;
`;
Label.displayName = 'S.Label';

export const PasteFrom = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 auto;
  align-items: center;
`;
PasteFrom.displayName = 'S.PasteFrom';
